const handleAsyncError = (promise) =>
  promise
    .then((data) => [data, undefined])
    .catch((error) => Promise.resolve([undefined, error || new Error('Promise Rejected')]));

export default handleAsyncError;
